import {useContext} from "react";
import ShopWidgetHandelContext from "../context/ShopWidgetProvider";


const UseShowShopWidget = () => {
  return useContext(ShopWidgetHandelContext);
}

export default UseShowShopWidget;